// extracted by mini-css-extract-plugin
export default {"error":"form_error__MhJIj"};